<script setup>
defineProps({
  message: "",
})
</script>

<template>

<div class="alert alert-danger" role="alert">
  <div class="d--alert-message">{{ message }}</div>
</div>
</template>
